import React from 'react';
import { st, classes } from './Content.st.css';
import { ContentProps } from './Content.types';

const getChildName = (children: React.ReactNode) => {
  if (React.isValidElement(children)) {
    if (typeof children.type === 'symbol') {
      return null;
    }

    if (typeof children.type !== 'string') {
      return (
        ('displayName' in children.type && children.type.displayName) ||
        ('name' in children.type && children.type.name)
      );
    }
  }

  return null;
};

const Content = (props: ContentProps) => {
  const { children, size = 'medium', dataHook } = props;
  const isEmptyStateContent = getChildName(children) === 'EmptyState';
  return (
    <div
      data-hook={dataHook}
      data-size={size}
      className={st(classes.root, {
        size,
        emptyStateContent: isEmptyStateContent,
      })}
    >
      {children}
    </div>
  );
};

Content.displayName = 'Card.Content';

export { Content };
